<template>
  <div class="manageInfo">
    <!-- 营业信息 -->
    <div class="wrapper-box">
      <listItem :label="'许可经营业务'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false">
        <!-- {{details.operationScope && details.operationScope.indexOf('1') != -1 ? '入境、国内旅游': ''}}
        {{details.operationScope && details.operationScope.indexOf('2') != -1 ? '出境旅游、': ''}}
        {{details.operationScope && details.operationScope.indexOf('3') != -1 ? '赴台旅游、': ''}}
        {{details.operationScope && details.operationScope.indexOf('4') != -1 ? '边境旅游': ''}} -->
        {{details.operationScopeList.join('、')}}
      </listItem>
      <rline></rline>
      <listItem :label="'经营状况'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false">{{details.operationStateStr || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'旅行社等级'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false">{{details.companyLevelStr || '暂无信息'}}</listItem>
      <rline></rline>
      <listItem :label="'旅行社特色服务'"
                :labelWidth="114"
                :ctnColor="'#333333'"
                :showRight="false">{{details.trafficinfo || '暂无信息'}}</listItem>
    </div>
  </div>
</template>
<script>
    import listItem from './components/list-itemone';
    import rline from './components/line';
    export default {
        components: {
            rline,
            listItem
        },

        data () {
            return {
                details: {
                    operationScopeList: []
                },
                operationScopeObj: {
                    '1': '入境、国内旅游',
                    '2': '出境旅游',
                    '3': '赴台旅游',
                    '4': '边境旅游'
                }
            };
        },

        computed: {},

        watch: {},

        methods: {
        },

        mounted () {
            if ((JSON.parse(localStorage.travelDetail)).travelAgencyDetails) {
                let details = (JSON.parse(localStorage.travelDetail)).travelAgencyDetails
                let list = []
                if (details.operationScope && typeof (details.operationScope) === 'object') {
                    details.operationScope.forEach(element => {
                        list.push(this.operationScopeObj[element])
                    });
                } else {
                    list = [this.operationScopeObj[details.operationScope] || '']
                }
                details.operationScopeList = list
                this.details = details
            }
        },
        created () { }
    };
</script>
<style scoped lang="less">
.manageInfo {
  width: 100%;
  height: 100%;
  background: rgba(251, 251, 251, 1);
  box-sizing: border-box;
  padding-top: 16px;
  .wrapper-box {
    width: 351px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 0 12px;
  }
}
</style>
